import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const fr = {
  // Navigation
  dashboard:'Tableau de bord', income:'Revenus', expenses:'Depenses',
  budgets:'Budgets', categories:'Categories', reports:'Rapports',
  family:'Famille', profile:'Profil', logout:'Deconnexion',
  login:'Connexion', register:'Inscription',
  // Actions
  save:'Enregistrer', cancel:'Annuler', delete:'Supprimer', edit:'Modifier', add:'Ajouter',
  confirm:'Confirmer', close:'Fermer', back:'Retour', search:'Rechercher',
  // Champs
  amount:'Montant', date:'Date', description:'Description', category:'Categorie',
  source:'Source', actions:'Actions', name:'Nom', email:'Email', password:'Mot de passe',
  currency:'Devise', language:'Langue', account_type:'Type de compte',
  // Messages
  loading:'Chargement...', saved:'Enregistre !', error:'Une erreur est survenue',
  required:'Champ obligatoire', success:'Succes',
  confirm_delete:'Etes-vous sur de vouloir supprimer ?',
  // Auth
  login_title:'Bienvenue', login_sub:'Connectez-vous a votre compte',
  register_title:'Creer un compte', register_sub:'Essai gratuit 15 jours - Sans carte bancaire',
  forgot_password:'Mot de passe oublie ?', reset_password:'Reinitialiser',
  send_reset:'Envoyer le lien', back_to_login:'Retour a la connexion',
  full_name:'Nom complet', personal:'Personnel', family_account:'Familial',
  already_account:'Deja un compte ?', no_account:'Pas encore de compte ?',
  password_min:'Mot de passe trop court (min. 6 caracteres)',
  account_created:'Compte cree ! Verifiez votre email avant de continuer.',
  verify_email_title:'Verifiez votre email',
  verify_email_msg:'Un lien de confirmation a ete envoye a votre adresse email. Veuillez cliquer sur ce lien pour activer votre compte.',
  verify_email_check:'Verifier mon email',
  verify_email_resend:'Renvoyer le lien',
  verify_email_success:'Email verifie ! Vous pouvez maintenant vous connecter.',
  verify_email_error:'Lien invalide ou expire.',
  // Dashboard
  total_income:'Revenus totaux', total_expense:'Depenses totales',
  balance:'Solde', savings:'Epargne', savings_pct:'Taux epargne',
  recent_transactions:'Transactions recentes', by_category:'Par categorie',
  no_data:'Aucune donnee ce mois-ci', this_month:'Ce mois',
  hello:'Bonjour', welcome_back:'Content de vous revoir',
  // Revenus
  add_income:'Ajouter un revenu', edit_income:'Modifier le revenu',
  income_source:'Source du revenu', no_income:'Aucun revenu ce mois-ci',
  income_deleted:'Revenu supprime', income_saved:'Revenu enregistre',
  // Depenses
  add_expense:'Ajouter une depense', edit_expense:'Modifier la depense',
  no_expenses:'Aucune depense ce mois-ci',
  expense_deleted:'Depense supprimee', expense_saved:'Depense enregistree',
  // Budgets
  add_budget:'Ajouter un budget', monthly_budget:'Budget mensuel',
  budget_progress:'Progression du budget', budget_saved:'Budget enregistre',
  budget_deleted:'Budget supprime', no_budgets:'Aucun budget ce mois-ci',
  spent:'Depense', remaining:'Restant', exceeded:'Depasse',
  // Categories
  add_category:'Ajouter une categorie', edit_category:'Modifier la categorie',
  category_name:'Nom de la categorie', category_icon:'Icone', category_color:'Couleur',
  category_saved:'Categorie enregistree', category_deleted:'Categorie supprimee',
  no_categories:'Aucune categorie',
  // Rapports
  reports_title:'Rapports financiers', trend_6m:'Tendance 6 mois',
  total_period:'Total sur la periode',
  // Famille
  family_group:'Groupe familial', create_group:'Creer un groupe',
  group_name:'Nom du groupe', add_member:'Ajouter un membre',
  member_name:'Nom du membre', member_role:'Role', member:'Membre', admin:'Administrateur',
  remove_member:'Retirer', no_group:'Aucun groupe familial',
  group_created:'Groupe cree !', member_added:'Membre ajoute !', member_removed:'Membre retire',
  // Profil
  profile_title:'Mon profil', update_profile:'Mettre a jour', change_password:'Changer le mot de passe',
  current_password:'Mot de passe actuel', new_password:'Nouveau mot de passe',
  profile_updated:'Profil mis a jour', password_updated:'Mot de passe mis a jour',
  delete_account:'Supprimer le compte', danger_zone:'Zone dangereuse',
  // Abonnement
  free_plan:'Essai gratuit', premium_plan:'Premium',
  upgrade:'Passer a Premium', upgrade_message:'Votre essai gratuit est termine.',
  trial_days_left:'Jours restants',
  trial_active:'Essai gratuit actif', trial_expired:'Essai gratuit expire',
  monthly:'Mensuel', yearly:'Annuel',
  // Pricing
  pricing_title:'Choisissez votre plan',
  pricing_trial_badge:'jours restants',
  pricing_trial_expired:'Votre essai est termine - Passez a Premium',
  popular:'POPULAIRE', secure_payment:'Paiement securise via PayPal',
  start_free:'Commencer gratuitement', upgrade_now:'Passer a Premium',
  all_features:'Toutes les fonctionnalites incluses',
  // Recu paiement
  payment_success:'Paiement confirme !',
  receipt_title:'Recu de paiement', receipt_plan:'Plan souscrit',
  receipt_amount:'Montant paye', receipt_date:'Date', receipt_id:'Reference',
  receipt_valid_until:'Valide jusqu\'au', receipt_download:'Telecharger le recu',
  receipt_back:'Retour au tableau de bord', welcome_premium:'Bienvenue en Premium !',
};

const en = {
  // Navigation
  dashboard:'Dashboard', income:'Income', expenses:'Expenses',
  budgets:'Budgets', categories:'Categories', reports:'Reports',
  family:'Family', profile:'Profile', logout:'Logout',
  login:'Login', register:'Register',
  // Actions
  save:'Save', cancel:'Cancel', delete:'Delete', edit:'Edit', add:'Add',
  confirm:'Confirm', close:'Close', back:'Back', search:'Search',
  // Fields
  amount:'Amount', date:'Date', description:'Description', category:'Category',
  source:'Source', actions:'Actions', name:'Name', email:'Email', password:'Password',
  currency:'Currency', language:'Language', account_type:'Account type',
  // Messages
  loading:'Loading...', saved:'Saved!', error:'Something went wrong',
  required:'Required field', success:'Success',
  confirm_delete:'Are you sure you want to delete?',
  // Auth
  login_title:'Welcome back', login_sub:'Sign in to your account',
  register_title:'Create an account', register_sub:'15-day free trial - No credit card required',
  forgot_password:'Forgot password?', reset_password:'Reset password',
  send_reset:'Send reset link', back_to_login:'Back to login',
  full_name:'Full name', personal:'Personal', family_account:'Family',
  already_account:'Already have an account?', no_account:'Don\'t have an account?',
  password_min:'Password too short (min. 6 characters)',
  account_created:'Account created! Please check your email before continuing.',
  verify_email_title:'Verify your email',
  verify_email_msg:'A confirmation link has been sent to your email address. Please click the link to activate your account.',
  verify_email_check:'Check my email',
  verify_email_resend:'Resend link',
  verify_email_success:'Email verified! You can now sign in.',
  verify_email_error:'Invalid or expired link.',
  // Dashboard
  total_income:'Total Income', total_expense:'Total Expenses',
  balance:'Balance', savings:'Savings', savings_pct:'Savings rate',
  recent_transactions:'Recent transactions', by_category:'By category',
  no_data:'No data this month', this_month:'This month',
  hello:'Hello', welcome_back:'Welcome back',
  // Income
  add_income:'Add income', edit_income:'Edit income',
  income_source:'Income source', no_income:'No income this month',
  income_deleted:'Income deleted', income_saved:'Income saved',
  // Expenses
  add_expense:'Add expense', edit_expense:'Edit expense',
  no_expenses:'No expenses this month',
  expense_deleted:'Expense deleted', expense_saved:'Expense saved',
  // Budgets
  add_budget:'Add budget', monthly_budget:'Monthly budget',
  budget_progress:'Budget progress', budget_saved:'Budget saved',
  budget_deleted:'Budget deleted', no_budgets:'No budgets this month',
  spent:'Spent', remaining:'Remaining', exceeded:'Exceeded',
  // Categories
  add_category:'Add category', edit_category:'Edit category',
  category_name:'Category name', category_icon:'Icon', category_color:'Color',
  category_saved:'Category saved', category_deleted:'Category deleted',
  no_categories:'No categories',
  // Reports
  reports_title:'Financial reports', trend_6m:'6-month trend',
  total_period:'Total over period',
  // Family
  family_group:'Family group', create_group:'Create group',
  group_name:'Group name', add_member:'Add member',
  member_name:'Member name', member_role:'Role', member:'Member', admin:'Admin',
  remove_member:'Remove', no_group:'No family group',
  group_created:'Group created!', member_added:'Member added!', member_removed:'Member removed',
  // Profile
  profile_title:'My profile', update_profile:'Update', change_password:'Change password',
  current_password:'Current password', new_password:'New password',
  profile_updated:'Profile updated', password_updated:'Password updated',
  delete_account:'Delete account', danger_zone:'Danger zone',
  // Subscription
  free_plan:'Free trial', premium_plan:'Premium',
  upgrade:'Upgrade to Premium', upgrade_message:'Your free trial has ended.',
  trial_days_left:'Days remaining',
  trial_active:'Free trial active', trial_expired:'Free trial expired',
  monthly:'Monthly', yearly:'Yearly',
  // Pricing
  pricing_title:'Choose your plan',
  pricing_trial_badge:'days remaining',
  pricing_trial_expired:'Your trial has ended - Upgrade to Premium',
  popular:'POPULAR', secure_payment:'Secure payment via PayPal',
  start_free:'Start for free', upgrade_now:'Upgrade to Premium',
  all_features:'All features included',
  // Receipt
  payment_success:'Payment confirmed!',
  receipt_title:'Payment receipt', receipt_plan:'Subscribed plan',
  receipt_amount:'Amount paid', receipt_date:'Date', receipt_id:'Reference',
  receipt_valid_until:'Valid until', receipt_download:'Download receipt',
  receipt_back:'Back to dashboard', welcome_premium:'Welcome to Premium!',
};

i18n.use(initReactI18next).init({
  resources: { fr:{ translation:fr }, en:{ translation:en } },
  lng: localStorage.getItem('bf_language') || 'fr',
  fallbackLng: 'fr',
  interpolation: { escapeValue: false },
});

export default i18n;